import React from "react";
import UsaBadge from "storefront/img/productsBadges/usa-badge.png";
import { StyledProductBadge } from "./ProductBadge.styled";

class ProductBadge extends React.PureComponent {
    badgeTag(product) {
        if (!product.tags) {
            return null;
        }

        const productTags = Array.isArray(product.tags)
            ? product.tags.map(tag => tag.trim())
            : (product.tags || "").split(",").map(tag => tag.trim());
        const badgeProductTag = productTags.find(x => x.startsWith('badge-')) || null;

        if (!badgeProductTag) {
            return null;
        }

        switch (badgeProductTag) {
            case 'badge-usa':
                return UsaBadge;
            default:
                return null;
        }
    }

    render() {
        const {
            product,
        } = this.props;

        const badgeTag = this.badgeTag(product);

        return (
        <>
            { badgeTag && (
                <StyledProductBadge src={badgeTag}></StyledProductBadge>
            )}
        </>
        );
    }
}

export default ProductBadge;
